export const PartnerGetMyTransactionSummary = 'PartnerGetMyTransactionSummary';
